export class HttpCodeError extends Error {
}